export const FCM_ADDITIONAL_COMMENTS_MAX = 2500;

export const FCM_ADDITIONAL_COMMENTS_PLACEHOLDER =
    'Enter any additional details relevant to the Field Case Management referral, such as claimant concerns, return-to-work status, work restrictions, or other case-specific information.';
